import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()

  const sharedStyles = {
    squareButton: {
      color: colors.color5,
      borderRadius: '50%',
      boxShadow: `1px 1px 2px ${colors.color10}`,
      padding: '12px',
      background: colors.color30,
      '&:hover': {
        background: colors.color30 + 'dd',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.7rem',
      },
      //marginBottom: '2px',
    },
    flexBasic: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    errorAmount: {
      fontSize: '11px',
      color: colors.color19,
    },
  }


  return {
    container: {
      padding: 6,
      justifyItems: 'center'
    },
    centerContainer: {
      maxWidth: '520px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '& .MuiTypography-root': {
        textAlign: "center"
      },
      margin: "auto"
    },
    commentStyles: {
      mt: -5,
      width: '75%',
      mx: 'auto'
    },
    commentContainer: {
      width: '100%'
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: ' center'
    },
    badge: {
      '& .MuiBadge-badge': {
        height: "20px",
        width: "20px",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: colors.color12,
        color: colors.color25,
        '& .MuiSvgIcon-root': {
          fontSize: '16px'
        }
      },
    },
    clip: {
      ...sharedStyles.squareButton,
    },
    lastButtons: {
      display: 'flex',
      gap: 2,
      alignItems: 'center'
    }
  }
}

export { useStyles }
